var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6329 7.11011L13.1589 3.09011C12.8047 2.86896 12.3955 2.75171 11.9779 2.75171C11.5604 2.75171 11.1512 2.86896 10.7969 3.09011L4.32394 7.13311C3.9559 7.36521 3.66379 7.69991 3.48361 8.09598C3.30344 8.49204 3.24307 8.93216 3.30994 9.36211L4.97994 19.3891C5.06822 19.914 5.34133 20.3901 5.74994 20.7312C6.15856 21.0723 6.67571 21.256 7.20794 21.2491H16.7899C17.3224 21.2562 17.8397 21.0726 18.2486 20.7315C18.6574 20.3904 18.9306 19.9142 19.0189 19.3891L20.6889 9.36211C20.7561 8.92426 20.6914 8.47631 20.5029 8.07541C20.3145 7.6745 20.0109 7.3388 19.6309 7.11111",
    stroke: "#AFADC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d7a0dd2e6184cad30bc5bb7727675e0a.svg";
export { ForwardRef as ReactComponent };